// apiService.js
import { get } from "aws-amplify/api";
import currentUserToken from "./CurrentUserToken";

// Fetch alarms
export const fetchCase = async (caseID) => {
  try {
    
    const restOperation = get({
      apiName: "TelemonitoringAPI",
      path: "/salesforce/case/get",
      options: {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${await currentUserToken()}`,
        },
        queryParams: {
          start_date:"2024-10-14",
          end_date:"2024-11-15",
          id: caseID,
        },
      },
    });
    const { body } = await restOperation.response;
    return await body.json();
  } catch (error) {
    console.error("Error fetching alarms:", error);
    throw error;
  }
};
